// Meta pixel (Blaze – 1651654973294663), a süti-kapun keresztül.
//
// A pixel CSAK marketing-hozzájárulás után töltődik be: a betöltés a
// `kapuzva` függvényen megy át (lásd `consent.ts`). Amíg a látogató nem
// döntött, vagy elutasította, semmilyen Meta-kód nem fut és süti sem kerül a
// böngészőbe. Ha később elfogadja, a kapu újratöltés nélkül elindítja.
//
// Az azonosító nem titok: a pixel-ID a böngészőben amúgy is látszik, ezért
// nem környezeti változó — így a Firebase- és a Railway-build is ugyanazt
// kapja.

import { kapuzva } from './consent';

const PIXEL_ID = '1651654973294663';

type Fbq = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

let betoltve = false;

/// A Meta hivatalos betöltő kódjának megfelelője, típusosan.
function letrehoz(): Fbq {
  const n = function (...args: unknown[]): void {
    if (n.callMethod) n.callMethod(...args);
    else n.queue.push(args);
  } as Fbq;
  n.queue = [];
  n.push = n;
  n.loaded = true;
  n.version = '2.0';
  window.fbq = n;
  if (!window._fbq) window._fbq = n;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  return n;
}

function betolt(): void {
  if (betoltve || typeof window === 'undefined') return;
  betoltve = true;
  const fbq = window.fbq ?? letrehoz();
  fbq('init', PIXEL_ID);
  fbq('track', 'PageView');
  // Hash-alapú útválasztás: minden képernyőváltás külön oldalmegtekintés.
  window.addEventListener('hashchange', () => {
    window.fbq?.('track', 'PageView');
  });
}

/// A pixel bekötése. Egyszer kell hívni, a süti-banner megjelenítése ELŐTT:
/// a banner ebből tudja, hogy van mire hozzájárulást kérni.
export function metaPixelBekotes(): void {
  kapuzva('marketing', betolt);
}

/// Konverziós esemény (pl. 'CompleteRegistration', 'Subscribe').
///
/// Hozzájárulás nélkül nem csinál semmit. Személyes adatot (e-mail, név,
/// telefonszám) NE adj át paraméterként.
///
/// Visszaadja, hogy elküldte-e az eseményt: így a hívó csak akkor vár (pl. egy
/// átirányítás előtt), ha tényleg ment ki valami.
export function metaEsemeny(nev: string, parameterek?: Record<string, unknown>): boolean {
  if (!betoltve || !window.fbq) return false;
  window.fbq('track', nev, parameterek ?? {});
  return true;
}
